import { i18n } from '@flecto/translations'
import { ESystemLanguage } from '@flecto/types'

function getLanguageEnum(language: string): ESystemLanguage {
  switch (language) {
    case 'pt':
      return ESystemLanguage.PT
    case 'es':
      return ESystemLanguage.ES
    case 'en':
    default:
      return ESystemLanguage.EN
  }
}

export function useLanguage() {
  return getLanguageEnum(i18n.language)
}
